import { Md5 } from 'ts-md5';

export const generateSpecialHeaders = (SPIKE_KEY: string) => {
  const date = new Date();
  const dateStr = date.toISOString();
  return {
    'xx-spk-mit': Md5.hashStr(`${SPIKE_KEY}${dateStr}`),
    'xx-time': dateStr,
  };
};
